<div class="card-body brandingBody">
    <a href= {{csodUrl}}>
      <img
        class="img-responsive"
        src="assets/images/nantellogo.png"
        alt="NANTeL"
      />
    </a>
  </div>
